import script from "./CondolenceUploadDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CondolenceUploadDialog.vue?vue&type=script&setup=true&lang=js"

import "./CondolenceUploadDialog.vue?vue&type=style&index=0&id=055d2e09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055d2e09"]])

export default __exports__